import { POST_CORPORATE_CLIENT_FAILURE, POST_CORPORATE_CLIENT_REQUEST, POST_CORPORATE_CLIENT_SUCCESS, PostCorporateClientActionTypes, PostCorporateClientState } from './types';

const defaultState: PostCorporateClientState = {
  isLoading: false,
  errorMessage: "",
};

export default function postCorporateClient(state = defaultState, action: PostCorporateClientActionTypes): PostCorporateClientState {
  switch (action.type) {
    case POST_CORPORATE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case POST_CORPORATE_CLIENT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case POST_CORPORATE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
